module.exports = __webpack_public_path__ + "static/media/5b56ea2a.jpg";